import {SODeleteEntityPermission} from '../../core/entity-permission/so-delete-entity-permission';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteEntityPermission extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteEntityPermission;
}